"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=require("./index61.js");var r=t.functionUncurryThis,i=r({}.toString),c=r("".slice),e=function(n){return c(i(n),8,-1)};exports.classofRaw=e;
